var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightarrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    transform: "matrix(-1 0 0 1 30 0)",
    fill: "#F38D00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7496 21.5026C12.8921 21.5026 13.0346 21.4501 13.1471 21.3376L18.0371 16.4476C18.8321 15.6526 18.8321 14.3476 18.0371 13.5526L13.1471 8.66264C12.9296 8.44514 12.5696 8.44514 12.3521 8.66264C12.1346 8.88014 12.1346 9.24014 12.3521 9.45764L17.2421 14.3476C17.6021 14.7076 17.6021 15.2926 17.2421 15.6526L12.3521 20.5426C12.1346 20.7601 12.1346 21.1201 12.3521 21.3376C12.4646 21.4426 12.6071 21.5026 12.7496 21.5026Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightarrow);
export default __webpack_public_path__ + "static/media/rightarrow.a760454a43b193f5103689dadad6e2a1.svg";
export { ForwardRef as ReactComponent };